import axios from 'axios';
import store from 'storejs';
import {ElMessage} from 'element-plus';

//import appStore from '@/pinia/index';
import {RequestConfig} from "@/common/request/vHttpInterface";
import {vCodeErrorHandle} from './errorHandle';
import {isIgnoreErrApi} from './specialApis';
import { getLocale } from '@/i18n';
import {router} from '@/router/router';

const sessionId = store.get('sessionId') || '';

let lastErrorMsg = '';
let lastErrorTime = 0;

function shouldShowError(msg: string): boolean {
  const now = Date.now();
  if (msg === lastErrorMsg && now - lastErrorTime < 500) return false;
  lastErrorMsg = msg;
  lastErrorTime = now;
  return true;
}

// 语言映射函数：将应用语言代码转换为 HTTP Accept-Language 格式
const getAcceptLanguage = (): string => {
  const locale = getLocale();
  const localeMap: Record<string, string> = {
    'zh-cn': 'zh-CN',
    'zh-tw': 'zh-TW',
    'en': 'en'
  };
  return localeMap[locale] || 'zh-CN';
};

const instance = axios.create({
  timeout: 20000,
  headers: {sessionId: sessionId},
});


instance.interceptors.request.use((config: RequestConfig) => {
  if (config.isCancel) {
    const CancelToken = axios.CancelToken;
    let cancel;
    config.cancelToken = new CancelToken(function executor(c) {
      cancel = c;
    });
    // appStore.axiosCancel.handleRequest({
    //   key: config.url || new Date().getTime().toString(),
    //   cancel: cancel
    // });
  }

  config.headers = {
    ...config.headers,
    sessionId: store.get('sessionId') || '',
    'Accept-Language': getAcceptLanguage()
  };
  return config;
});


instance.interceptors.response.use(res => {
  vCodeErrorHandle(res);
  return res;
}, error => {
  const response = error.response;
  let errorMessage = error.message;
  switch (response.status) {
    case 401:
    case 403:
      if (router.currentRoute.value.path !== '/login') {
        router.push('/login');
      }
      return Promise.reject(response);
    case 404:
      errorMessage = "接口地址错误";
      break;
    case 500:
      errorMessage = "服务器出错";
      break;
  }
  console.log('error-----错误');
  if (!isIgnoreErrApi(error) && shouldShowError(errorMessage)) {
    ElMessage.error(errorMessage);
  }
  return Promise.reject(response);
});

export default instance;
